import { userStorage } from '@/db/storage';

async function importDeck(uid) {
    console.log("Importing...");
    return new Promise((resolve, reject) => {
        try {
            // tslint:disable no-angle-bracket-type-assertion whitespace
            const file      = (<HTMLInputElement>document.getElementById('btnFiles')).files[0];
            const ref       = userStorage.child(`${uid}/deckImports/${file.name}`);
            const task      = ref.put(file);
            task.on('state_changed', 
                (progress) => {
                    // Update progress bar
                },
                (err) => {
                    // There was an error!
                    reject(err);
                },
                () => {
                    // Complete!
                    resolve();
                },
            );
        } catch (error) {
            reject(error);
        }
    });
}

export default importDeck;
